import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import Html from './html';
import shared from './shared';
import methodModel from '../../methods/methods';

function Staff() {
  const searchState = { data: '' };
  const [filters, setFilter] = useState({ page: 1, count: 10, search: '' });
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loaging, setLoader] = useState(true);
  const history = useNavigate();

  useEffect(() => {
    setFilter({ ...filters, search: searchState.data });
    getData({ search: searchState.data, page: 1 });
  }, []);

  const sortClass = (key) => {
    let cls = 'fa-sort';
    if (filters.key == key && filters.sorder == 'asc') cls = 'fa-sort-up';
    else if (filters.key == key && filters.sorder == 'desc') cls = 'fa-sort-down';
    return `fa ${cls}`;
  };

  const sorting = (key) => {
    let sorder = 'asc';
    if (filters.key == key) {
      if (filters.sorder == 'asc') {
        sorder = 'desc';
      } else {
        sorder = 'asc';
      }
    }
    const sortBy = `${key} ${sorder}`;
    setFilter({
      ...filters, sortBy, key, sorder,
    });
    getData({ sortBy, key, sorder });
  };

  const getData = (p = {}) => {
    setLoader(true);
    loader(true)
    const filter = { ...filters, ...p, role: shared?.role };
    ApiClient.get(shared.listApi, filter).then((res) => {
      if (res.success) {
        console.log(res?.data,"Data is here ---")
        setData(res.data);
        setTotal(res.total);
      }
      loader(false)
      setLoader(false);
    });
  };

  const clear = () => {
    const f = {
      groupId: '',
      search: '',
      status: '',
      page: 1,
      role: '',
    };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  };

  const filter = (p = {}) => {
    const f = { page: 1, ...p };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  };

  const deleteItem = (id) => {
    console.log(id,"id")
    methodModel.DeleteData(shared.deleteApi,id,shared.addTitle,getData);
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  };
  const count = (e) => {
    setFilter({ ...filters, count: e });
    getData({ ...filters, count: e });
  };
  const changestatus = (e) => {
    setFilter({ ...filters, status: e, page: 1 });
    getData({ status: e, page: 1 });
  };

  const statusChange = (itm) => {
  methodModel.StatusChange(shared.statusApi,itm,shared.addTitle,getData)
  };

  const edit = (id) => {
    history(`/${shared.route}/edit/${id}`);
  };

  const view = (id) => {
    const url = `/${shared.route}/detail/${id}`;
    history(url);
  };


  return (
    <Html
      edit={edit}
      view={view}
      clear={clear}
      sortClass={sortClass}
      sorting={sorting}
      count={count}
      pageChange={pageChange}
      deleteItem={deleteItem}
      filters={filters}
      setFilter={setFilter}
      filter={filter}
      loaging={loaging}
      data={data}
      total={total}
      statusChange={statusChange}
      changestatus={changestatus}
    />
  );
}

export default Staff;
